

const Solutions = () => {
    return <h1>Solutions Page</h1>;
  };
  
  export default Solutions;